import {handleActions} from 'redux-actions'
import maskPhoneNumber from 'utils/maskPhoneNumber'
import {
  updateUser,
  updateMailAction,
  updateProfile,
  updateDisplayName,
  updateSecretQuestion,
  updateRamblerMailPhone,
  addAccount,
  addContact,
  confirmContact,
  cancelContact,
  cancelSocialProfile,
  updateDefaultChampionat,
  addWebAuthnKey,
  deleteWebAuthnKey,
  updateEmailCredentials,
  updateIs2faEnabled,
  updateAccounts
} from './actions'

export const initialState = {
  display: null,
  profile: null,
  info: null,
  type: undefined
}

export default handleActions(
  {
    [updateUser](state, {payload}) {
      if (payload == null) {
        return {
          display: null,
          profile: null,
          info: null,
          type: null
        }
      }

      const {ramblerMailPhone} = payload.info

      return {
        ...payload,
        info: {
          ...payload.info,
          ...(ramblerMailPhone && {
            ramblerMailPhone: `+${ramblerMailPhone}`
          })
        }
      }
    },

    [updateMailAction](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          ramblerMailAction: payload || null
        }
      }
    },

    [updateSecretQuestion](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          question: payload
        }
      }
    },

    [updateRamblerMailPhone](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          ramblerMailPhone: payload
            ? maskPhoneNumber(payload.replace(/\s/, ''))
            : null,
          ramblerMailPhoneTimestamp: Date.now() * 1e3
        }
      }
    },

    [updateDisplayName](state, {payload}) {
      return {
        ...state,
        display: {
          ...state.display,
          displayName: payload
        }
      }
    },

    [updateProfile](state, {payload}) {
      const {birthday, ...nextProfile} = payload

      return {
        ...state,
        profile: {
          ...state.profile,
          ...nextProfile,
          ...(birthday != null && {
            birthdate: birthday
          })
        }
      }
    },

    [addAccount](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          rawAccounts: {
            ...state.info.rawAccounts,
            accounts: state.info.rawAccounts.accounts.concat(payload)
          }
        }
      }
    },

    [updateAccounts](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          rawAccounts: {
            ...state.info.rawAccounts,
            accounts: payload
          }
        }
      }
    },

    [addContact](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          contacts: state.info.contacts.concat(payload)
        }
      }
    },

    [confirmContact](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          contacts: state.info.contacts.map((contact) =>
            contact.contact === payload ? {...contact, type: 'EMAIL'} : contact
          )
        }
      }
    },

    [cancelContact](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          contacts: state.info.contacts.filter(
            (contact) => contact.contact !== payload
          )
        }
      }
    },

    [cancelSocialProfile](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          socialProfiles: state.info.socialProfiles.filter(
            (profile) => profile.extUid !== `${payload.id}@${payload.provider}`
          )
        }
      }
    },

    [updateDefaultChampionat](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          championat: {
            ...state.info.championat,
            default: {
              accountId: payload,
              provider: 'championat'
            }
          }
        }
      }
    },

    [addWebAuthnKey](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          webAuthnKeys: state.info.webAuthnKeys.concat(payload)
        }
      }
    },

    [deleteWebAuthnKey](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          webAuthnKeys: state.info.webAuthnKeys.filter(
            (key) => key.publicId !== payload
          )
        }
      }
    },

    [updateEmailCredentials](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          emailCredentials: payload
        }
      }
    },

    [updateIs2faEnabled](state, {payload}) {
      return {
        ...state,
        info: {
          ...state.info,
          emailCredentials: [
            ...state.info.emailCredentials.map((credential) => {
              if (credential.account === payload.email) {
                return {
                  ...credential,
                  is2faEnabled: payload.is2faEnabled
                }
              } else {
                return credential
              }
            })
          ]
        }
      }
    }
  },
  initialState
)
